

import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator';
import { Draggable } from 'draggable-vue-directive';
import * as _ from 'lodash';
import { Guid } from 'guid-typescript';
import $ from 'jquery';
import { identity } from 'lodash';
import { IVueWindow, IPortfolioWindowReduced } from '@/types/Interface';

@Component({
  components: {
  },
  directives: {
    Draggable,
  },
})
export default class APortfolioWindow extends Vue implements IVueWindow {
    public visible: boolean;

    public handleId:string = 'handle-id';

    public draggableValue: any = {
      handle: undefined,
    };

    @Prop({ default: () => Guid.create() }) readonly id!: Guid;

    public refWindowContent?: Element = undefined;

    public refGetter = () => {
      if (!this.refWindowContent) {
        this.refWindowContent = this.$refs.windowcontent as Element;
      }
      return this.refWindowContent;
    }

    public instance: IPortfolioWindowReduced = { id: this.id.toString(), instance: this }

    constructor() {
      super();
      this.visible = true;
      this.draggableValue.handle = this.$refs[this.handleId];
      this.refWindowContent = this.$refs.windowcontent as Element;
    }

    public addFocus(): void {
      const element = this.refGetter();
      if (_.isNil(element)) {
        console.log('element windowcontent introuvable en ajout');
        return;
      }
      $(element).addClass('focus-on');
    }

    public removeFocus(): void {
      const element = this.refGetter();
      if (_.isNil(element)) {
        console.log('element windowcontent introuvable en suppression');
        return;
      }
      $(element).removeClass('focus-on');
    }

    public redirect(link: string): void {
      switch (link) {
        case 'linkedin':
          window.open('https://www.linkedin.com/in/jean-david-nelson/', '_blank');
          break;
        case 'github':
          window.open('https://github.com/jdavidnel', '_blank');
          break;
        default:
          window.location.href = 'http://localhost:8080/';
          break;
      }
    }

    public close(): void {
      console.log('Emit close event from windows');
      this.visible = false;
      this.$emit('Window::Close', this.instance);
      // this.$destroy();
    }

    public focusWindow(): void {
      console.log('Emit focus event from windows');
      this.$emit('Window::Focus::Get', this.instance);
    }

    public open() {
      this.visible = true;
    }

    public reduce() {
      console.log('Emit reduce event from windows');
      this.visible = false;
      this.$emit('Window::Reduce', this.instance);
    }
}
